import { Skill } from "../../../types/jobs";

export function useJobSkills() {
  const getAvailableSkills = (
    skillOptions: Skill[],
    selectedSkills?: Skill[]
  ): Skill[] | [] => {
    if (selectedSkills && selectedSkills.length !== 0) {
      return skillOptions?.filter(
        (skill) =>
          !selectedSkills?.some(
            (selectedSkill) => selectedSkill.slug === skill.slug
          )
      );
    } else {
      return skillOptions;
    }
  };

  return {
    getAvailableSkills,
  };
}
